export default class FormSendHandler {
    private sendButton: HTMLInputElement | null;

    constructor(private form: HTMLFormElement) {
        this.sendButton = this.form.querySelector("[type='submit']");
    }

    public init = async () => {
        if (!this.sendButton) return;

        this.listeners();
    };

    private onSubmitForm = () => {
        if (!this.sendButton) return;

        this.sendButton!.disabled = false;
    };

    private beforeSubmitForm = () => {
        if (!this.sendButton) return;

        this.sendButton!.disabled = true;
    };

    private listeners = () => {
        document.addEventListener("wpcf7submit", this.onSubmitForm, false);
        document.addEventListener("wpcf7beforesubmit", this.beforeSubmitForm, false);
    };
}
